import { useState } from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import BasicModal from "./Modals/BasicModal";
import Fleetidtable from "./ChildData/Fleetidtable";
import { BarChart } from "@rsuite/icons";

const Psfcards = ({ title, icon, iconBgColor, psfces, psfscore, psdssat, year, barChart, DssatChart, cesChart }) => {
    const [modalContent, setModalContent] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = (content) => {
        setModalContent(content);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalContent(null);
    };

    // console.log(isModalOpen)
    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-2 w-full md:w-96 max-w-md">
            {/* Header */}
            <div className="flex items-center gap-3 mb-2">
                <div className={`${iconBgColor} rounded-lg p-2`}>
                    {icon}
                </div>
                <h2 className="text-xl font-semibold text-gray-800 uppercase tracking-wide">
                    {title} ({year})
                </h2>
            </div>

            {/* Metrics */}
            <div className="gap-4 flex items-center justify-between mb-2">
                {/* PSF Score */}
                <div className="flex flex-col items-center text-center">
                    <div>PSF Score</div>
                    <div className="text-[rgb(26,115,232)] font-bold">{psfscore}%</div>
                    <div
                        className="bg-gray-100 hover:bg-gray-200 p-2 rounded-full shadow-md cursor-pointer transition-all"
                        onClick={() => openModal(barChart)}
                    >
                        <FaExternalLinkAlt className="text-gray-600" size={14} />
                    </div>
                </div>

                {/* Customer Effort */}
                <div className="flex flex-col items-center text-center">
                    <div>Customer Effort</div>
                    <div className="text-[#34A853] font-bold">{psfces}</div>
                    <div
                        className="bg-gray-100 hover:bg-gray-200 p-2 rounded-full shadow-md cursor-pointer transition-all"
                        onClick={() => openModal(cesChart)}

                    >
                        <FaExternalLinkAlt className="text-gray-600" size={14} />
                    </div>
                </div>

                {/* Dissatisfaction */}
                <div className="flex flex-col items-center text-center">
                    <div>Dissatisfaction</div>
                    <div className="text-[#EA4335] font-bold">{psdssat}%</div>
                    <div
                        className="bg-gray-100 hover:bg-gray-200 p-2 rounded-full shadow-md cursor-pointer transition-all"
                        onClick={() => openModal(DssatChart)}
                    >
                        <FaExternalLinkAlt className="text-gray-600" size={14} />
                    </div>
                </div>
            </div>

            {/* Modal */}
            <BasicModal
                title="Details"
                open={isModalOpen}
                handleCloseModal={closeModal}
            >
                {modalContent}
            </BasicModal>
        </div>
    );
};

export default Psfcards;
